import { getSDK } from '@/graphql/client';
import { useMutation } from 'react-query';

export default function useUpdateDeviceInfo() {
  return useMutation(getSDK().publicUpdateDeviceInfo, {
    onSuccess: (data, variables, context) => {},
  });
}
